export interface DailyPnlRecord {
  date: string
  pnl: number
  returnOnBP: number
  returnOnGMV: number
  cumulativePnl: number
  drawdown: number
}

export interface PnlStatistics {
  mean: number
  stdDev: number
  plus1Std: number
  minus1Std: number
  plus2Std: number
  minus2Std: number
}

export interface AxisLabelConfig {
  interval: number
  labelCount: number
}

export function extendPnlData(data: DailyPnlRecord[], requiredLength: number): DailyPnlRecord[] {
  const missingLength = requiredLength - data.length

  if (missingLength <= 0) {
    return [...data]
  }

  const extended = [...data]
  const firstDate = data.length > 0 ? new Date(data[0].date) : new Date()

  for (let i = 1; i <= missingLength; i++) {
    const newDate = new Date(firstDate)
    newDate.setDate(firstDate.getDate() - i)
    extended.unshift({
      date: newDate.toISOString().split('T')[0],
      pnl: 0,
      returnOnBP: 0,
      returnOnGMV: 0,
      cumulativePnl: 0,
      drawdown: 0,
    })
  }

  return extended
}

export function calculatePnlStatistics(data: DailyPnlRecord[]): PnlStatistics {
  const pnlValues = data.length > 0 ? data.map((d) => d.pnl) : [0]

  const mean = pnlValues.reduce((sum, value) => sum + value, 0) / pnlValues.length
  const variance = pnlValues.reduce((sum, value) => sum + Math.pow(value - mean, 2), 0) / pnlValues.length
  const stdDev = Math.sqrt(variance)

  return {
    mean,
    stdDev,
    plus1Std: Number((mean + stdDev).toFixed(2)),
    minus1Std: Number((mean - stdDev).toFixed(2)),
    plus2Std: Number((mean + 2 * stdDev).toFixed(2)),
    minus2Std: Number((mean - 2 * stdDev).toFixed(2)),
  }
}

export function calculateAxisLabelInterval(dataLength: number, config: AxisLabelConfig): number {
  return Math.max(1, Math.floor(dataLength / config.labelCount))
}
